module.exports = __webpack_public_path__ + "static/media/Dashboard_02-People.3c67ad42.jpg";